import { addToast, addErrorToast } from "@src/features/app/utils/toast";

const returnValue = {
  addToast,
  addErrorToast,
};
export const useToast = (): typeof returnValue => {
  return returnValue;
};
